import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

let hue = ~~(Math.random() * 360);

const setBg = () => {
    hue = hue === 361 ? 0 : hue + 1;

    document.querySelector('meta[name="theme-color"]').setAttribute("content", `hsl(${hue},80%,30%)`);
    document.documentElement.style.setProperty("--hue", hue);
}

setBg()

setInterval(setBg, 512);

ReactDOM.render(
    <React.StrictMode>
        <App/>
    </React.StrictMode>,
    document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
